module.exports = __webpack_public_path__ + "static/media/lettuce.ec4ead1c.png";